import { selectAuthState } from '@core/core.state';
import { createSelector } from '@ngrx/store';
import { AuthState } from './auth.models';

export const selectAuth = createSelector(selectAuthState, (state: AuthState) => state);
